(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-support-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'getfreon_delivery_zip';

    const addBusinessDays = (date, days) => {
      const result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
      }
      return result;
    };

    const isRestrictedZip = (zip) => {
      const prefix = Number(zip.slice(0, 3));
      return (
        (prefix >= 6 && prefix <= 9) ||
        (prefix >= 90 && prefix <= 98) ||
        prefix === 340 ||
        (prefix >= 962 && prefix <= 969) ||
        (prefix >= 995 && prefix <= 999)
      );
    };

    const parseZipList = (value) => new Set(
      (value || '')
        .split(/[\s,;]+/)
        .map((zip) => zip.trim().slice(0, 5))
        .filter((zip) => /^\d{5}$/.test(zip))
    );

    const parsePrefixRanges = (value) => (value || '')
      .split(/[\s,;]+/)
      .map((range) => range.trim())
      .filter(Boolean)
      .map((range) => {
        const [startValue, endValue = startValue] = range.split('-');
        const start = Number(startValue);
        const end = Number(endValue);
        return Number.isInteger(start) && Number.isInteger(end) && start >= 0 && end <= 999 && start <= end
          ? [start, end]
          : null;
      })
      .filter(Boolean);

    const isInPrefixRanges = (zip, ranges) => {
      const prefix = Number(zip.slice(0, 3));
      return ranges.some(([start, end]) => prefix >= start && prefix <= end);
    };

    const init = (root) => {
      if (root.dataset.shippingSupportInitialized === 'true') return;
      root.dataset.shippingSupportInitialized = 'true';

      const toggle = root.querySelector('[data-delivery-toggle]');
      const form = root.querySelector('[data-delivery-form]');
      const input = root.querySelector('[data-delivery-zip]');
      const error = root.querySelector('[data-delivery-error]');
      const title = root.querySelector('[data-delivery-title]');
      const subtitle = root.querySelector('[data-delivery-subtitle]');
      const fastZips = parseZipList(root.dataset.fastZips);
      const mediumZips = parseZipList(root.dataset.mediumZips);
      const farZips = parseZipList(root.dataset.farZips);
      const fastPrefixRanges = parsePrefixRanges(root.dataset.fastPrefixRanges);
      const mediumPrefixRanges = parsePrefixRanges(root.dataset.mediumPrefixRanges);

      const getDeliveryWindow = (zip) => {
        if (fastZips.has(zip)) return [Number(root.dataset.fastMin || 2), Number(root.dataset.fastMax || 3)];
        if (mediumZips.has(zip)) return [Number(root.dataset.mediumMin || 3), Number(root.dataset.mediumMax || 4)];
        if (farZips.has(zip)) return [Number(root.dataset.farMin || 3), Number(root.dataset.farMax || 4)];
        if (isInPrefixRanges(zip, fastPrefixRanges)) return [Number(root.dataset.fastMin || 2), Number(root.dataset.fastMax || 3)];
        if (isInPrefixRanges(zip, mediumPrefixRanges)) return [Number(root.dataset.mediumMin || 3), Number(root.dataset.mediumMax || 4)];
        return [Number(root.dataset.fallbackMin || 3), Number(root.dataset.fallbackMax || 4)];
      };

      const renderZip = (zip) => {
        if (isRestrictedZip(zip)) {
          title.textContent = root.dataset.reviewTitle;
          subtitle.textContent = `${zip} — ${root.dataset.reviewText}`;
        } else {
          const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
          const dispatchDays = Number(root.dataset.dispatchDays || 1);
          const shipDate = addBusinessDays(now, dispatchDays);
          const [minimum, maximum] = getDeliveryWindow(zip);
          const start = addBusinessDays(shipDate, minimum);
          const end = addBusinessDays(shipDate, maximum);
          const format = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          title.textContent = `${root.dataset.estimatePrefix} ${format(start)} – ${format(end)}`;
          subtitle.textContent = `${root.dataset.deliveringPrefix} ${zip}, United States`;
        }
        toggle.textContent = root.dataset.changeLabel;
      };

      toggle.addEventListener('click', () => {
        form.hidden = !form.hidden;
        toggle.setAttribute('aria-expanded', String(!form.hidden));
        if (!form.hidden) input.focus();
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const zip = input.value.trim().slice(0, 5);
        if (!/^\d{5}$/.test(zip)) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          return;
        }
        error.hidden = true;
        input.removeAttribute('aria-invalid');
        renderZip(zip);
        form.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        try { localStorage.setItem(storageKey, zip); } catch (error) { /* Storage may be unavailable. */ }
      });

      try {
        const savedZip = localStorage.getItem(storageKey);
        if (/^\d{5}$/.test(savedZip || '')) {
          input.value = savedZip;
          renderZip(savedZip);
        }
      } catch (error) { /* Storage may be unavailable. */ }
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-shipping-support]').forEach(init);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
